import { render, staticRenderFns } from "./Busca-avancada-colaboradores.vue?vue&type=template&id=6e7117fe&scoped=true&"
import script from "./Busca-avancada-colaboradores.vue?vue&type=script&lang=js&"
export * from "./Busca-avancada-colaboradores.vue?vue&type=script&lang=js&"
import style0 from "./Busca-avancada-colaboradores.vue?vue&type=style&index=0&id=6e7117fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7117fe",
  null
  
)

export default component.exports